$(function () {
	$(document).on('click', '.soc__link',function (e) {
		const sharer = new Sharer(e.target);
		sharer.share();
	});
});
